import {useAppDispatch, useAppSelector} from "../../../redux/redux.hook";
import React from "react";
import {CreateWorkerData, UpdateWorkerInput} from "./types";
import {shallowEqual} from "react-redux";
import {selectAllWorkers, selectWorkerById} from "./workers.slice";
import {
    addWorkerServiceThunk,
    createWorkerThunk,
    getWorkerThunk,
    listWorkersThunk,
    removeWorkerServiceThunk,
    updateWorkerStatusThunk,
    updateWorkerThunk
} from "./workers.thunk";

interface Name {
    firstName: string;
    lastName: string;
}

export function useWorkers() {
    const dispatch = useAppDispatch();
    const workers = useAppSelector(selectAllWorkers, shallowEqual);

    const [loading, setLoading] = React.useState(false);

    React.useEffect(() => {
        setLoading(true);
        dispatch(listWorkersThunk())
            .catch(() => {
            })
            .finally(() => setLoading(false));
    }, [dispatch]);

    return {workers, loading};
}

export function useCreateWorker() {
    const dispatch = useAppDispatch();
    return {createWorker: (dto: CreateWorkerData) => dispatch(createWorkerThunk(dto))};
}

export function useUpdateWorker() {
    const dispatch = useAppDispatch();
    return {updateWorker: (id: string, dto: UpdateWorkerInput) => dispatch(updateWorkerThunk({id, dto}))};
}

export function useUpdateWorkerStatus() {
    const dispatch = useAppDispatch();
    return {updateWorkerStatus: (id: string, active: boolean) => dispatch(updateWorkerStatusThunk({id, active}))};
}

export function useWorker(id: string | null | undefined) {
    const dispatch = useAppDispatch();

    const worker = useAppSelector((state) => {
        if (id) {
            return selectWorkerById(state, id);
        }
    });
    const error = useAppSelector((state) => {
        if (id) {
            return state.workers.errors[id];
        }
    });

    React.useEffect(() => {
        if (id && !worker && !error) {
            dispatch(getWorkerThunk({id}))
        }
    }, [dispatch, error, id, worker])

    return {
        worker,
        error
    }
}

export function useUpdateWorkerName() {
    const {updateWorker} = useUpdateWorker();

    const updateWorkerName = (name: Name, workerId: string) => updateWorker(workerId, {
        firstName: name.firstName,
        lastName: name.lastName
    })

    return {
        updateWorkerName
    }
}

export function useUpdateWorkerService() {
    const dispatch = useAppDispatch();

    return {
        addWorkerService: (workerId: string, serviceId: string) =>
            dispatch(addWorkerServiceThunk({workerId, serviceId})),
        removeWorkerService: (workerId: string, serviceId: string) =>
            dispatch(removeWorkerServiceThunk({workerId, serviceId})),
    }
}